// export default CustomToolBar;
import React from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid';
import { Button, Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Importa la función autoTable correctamente
import Formatters from '../../scripts/formatters';
import LogoFS from '../../assets/images/logoFS.png';


const CustomExportPdf = (props) => {
  const { codEmpleado, additionalTitle, tableRef, totales } = props; // Recibir referencia a la tabla
  
  const exportPDF = () => {
    try {      
      // Crear un nuevo documento PDF
      const doc = new jsPDF();
      
      // Insertar el logo en la esquina superior derecha
      const imgWidth = 40; // Ajusta el ancho del logo según sea necesario
      const imgHeight = 20; // Ajusta la altura del logo según sea necesario
      const x = doc.internal.pageSize.getWidth() - imgWidth - 10; // Calcula la posición x para la esquina derecha
      const y = 4; // Ajusta la posición y según sea necesario
      
      doc.addImage(LogoFS, 'PNG', x, y, imgWidth, imgHeight);
      doc.text("Historial de Vacaciones - FS Talento", 14, 10);

      // **Título adicional (debajo)**
      if (additionalTitle) {
        doc.setFontSize(12)
        doc.text(codEmpleado + " - " + additionalTitle, 14, 18); // Cambia la coordenada 'y' para moverlo hacia abajo
      }      

      // Extraer datos de la tabla
      const columns = [
        "No.", "Fecha Solic.", "Fecha inicio", "Fecha final", 
        "Tipo de Vacación", "Cantidad", "Saldo", "Observaciones"
      ];
  
      // 
      const rows = tableRef?.map(row => ([
        row.Consecutivo, 
        Formatters.dateFormatter(row.Fecha),
        Formatters.dateFormatter(row.FechaInicio), 
        Formatters.dateFormatter(row.FechaFinal),
        row.Tipo, 
        row.Cantidad, 
        row.Saldo, 
        row.Observaciones
      ])) || [];
      
      autoTable(doc, { 
        head: [columns], 
        body: rows,
        startY: 25,
        columnStyles: {
          0: { cellWidth: 15, halign: 'center' }, // No. (Más pequeño)
          1: { cellWidth: 20, halign: 'center' }, // Fecha solic.
          2: { cellWidth: 20, halign: 'center' }, // Fecha inicio
          3: { cellWidth: 20, halign: 'center' }, // Fecha final
          4: { cellWidth: 35, halign: 'center' }, // Tipo (Reducido)
          5: { cellWidth: 20, halign: 'center' }, // Cantidad (Más pequeño)
          6: { cellWidth: 15, halign: 'center' }, // Saldo (Más pequeño)
          7: { cellWidth: 'auto' }, // Observaciones (auto para que tome el espacio restante)
        },        
        styles: {
          fontSize: 9,
          lineColor: [0, 0, 0], // Black border
          lineWidth: 0.2 // Border width
        },
        headStyles: {
          fillColor: [200, 200, 200], // light gray
          textColor: [0, 0, 0], // Black
          lineWidth: 0.2,
          lineColor: [0, 0, 0]
        },
        bodyStyles: {
          textColor: [0, 0, 0],
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // light gray
        }
      });
  
      // **Modificar el footer**      
      const footerY = doc.internal.pageSize.height - 10;
      const colWidth = doc.internal.pageSize.width / 4; // Divide el ancho en 4 columnas

      doc.setFontSize(11) // Ajusta el tamaño de fuente según sea necesario
      doc.setFont('helvetica', 'bold') // Establece la fuente en negrita      
      doc.setTextColor(0, 0, 0) // Establece el color del texto en negro (RGB)
      doc.text(`Acumulado: ${Formatters.currencyFormatter(totales.acumulado)}`, 14, footerY, {baseline: 'bottom'})
      doc.text(`Descansados: ${Formatters.currencyFormatter(totales.descansado)}`, 14 + colWidth, footerY, {baseline: 'bottom'})
      doc.text(`Pagados: ${Formatters.currencyFormatter(totales.pagado)}`, 14 + (colWidth * 2), footerY, {baseline: 'bottom'})
      doc.setTextColor(255, 0, 0) // Restablece el color del texto a rojo (RGB)
      doc.text(`Saldo: ${Formatters.currencyFormatter(totales.acumulado - totales.descansado - totales.pagado)}`, 14 + (colWidth * 3), footerY, {baseline: 'bottom'})

      doc.save(`Historial_Vacaciones_${codEmpleado}.pdf`)
    } catch (error) {
      console.error(error)
    }
  };

  return (
    <GridToolbarContainer className='d-flex justify-content-center align-items-center'>
      {additionalTitle && (
        <Typography component="div" sx={{ flexGrow: 1 }} fontSize={16} fontWeight='bold'>
          {additionalTitle}
        </Typography>
      )}
      <div className='hide-to-print'>
        <Button
          variant='outlined'
          className='text-transform-none mb-1 mx-3'
          color='info'
          startIcon={<PictureAsPdfOutlinedIcon />}
          onClick={exportPDF}
          size='small'
        >
          EXPORTAR PDF
        </Button>
      </div>
    </GridToolbarContainer>
  );
}

export default CustomExportPdf;